import { currentLineLob, isDDMIntegrationActive } from './helper';
import { masterModalHelper } from 'ui/redux/actions';
import { ADD_DEFAULT_VALUES } from 'ui/redux/action-types/helperActionTypes';

const AddDefaultValues = (url, schema, dataModel = {}, role = 'UW', extraparams = {}) => {
  const lob = currentLineLob();
  schema = masterModalHelper(ADD_DEFAULT_VALUES, lob, [
    url,
    schema,
    dataModel,
    role,
    extraparams,
    isDDMIntegrationActive(),
  ]);
  return schema;
};

export { AddDefaultValues };
